import { Services } from '@omnia/ui/src/lib'
import { cinemaService } from '@/shared/services/cinema.service'
import { cmsDataService } from '@/shared/services/cms.data.service'
import { urlService } from '@/shared/services/url.service'
import { cmsService } from './cms.service'
import { navigationService } from './navigation.service'

export const initServices = () => {
    Services.CmsDataService = cmsDataService
    Services.CmsService = cmsService as unknown as typeof Services.CmsService
    Services.NavigationService = navigationService as unknown as typeof Services.NavigationService
    Services.UrlService = urlService as unknown as typeof Services.UrlService
    Services.CinemaService = cinemaService as unknown as typeof Services.CinemaService

    urlService.setNavigationService(navigationService)
}
